import { FlyoverShell } from "./flyover-shell";
import { ScorecardPanelContent } from "./scorecard-panel";
import type { SessionRowData } from "./session-row";
import { AskAboutSourceAction } from "./ask-about-source-action";

/**
 * The workspace source panel per the comp's #thread-source contract: the shared
 * 472px push panel (see FlyoverShell) carrying scorecard content. Opened from
 * read rows, citation chips, ledger entries, and record rows; Esc or Close
 * dismisses with focus restored to the trigger.
 *
 * "Ask about this" seeds a new thread scoped to this source (manifest
 * focus) — the flyover-to-thread loop of the RD workspace IA.
 */
export function SourceFlyover({
  rdId,
  rdSlug,
  session,
  onClose,
}: {
  rdId: string;
  rdSlug: string;
  session: SessionRowData | null;
  onClose: () => void;
}) {
  return (
    <FlyoverShell openKey={session?.id ?? null} onClose={onClose}>
      {session && (
        <ScorecardPanelContent
          key={session.id}
          rdId={rdId}
          rdSlug={rdSlug}
          session={session}
          onClose={onClose}
          headerActions={
            <AskAboutSourceAction rdSlug={rdSlug} source={{ type: "session", id: session.id }} />
          }
        />
      )}
    </FlyoverShell>
  );
}
